import { render, staticRenderFns } from "./smsGateway.vue?vue&type=template&id=b0b0af0a"
import script from "./smsGateway.vue?vue&type=script&lang=js"
export * from "./smsGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports